import React from "react";

export default function WeatherForecastDay(props) {
  const { weeklyData } = props;
  if (!weeklyData) return null;

  function maxTemperature() {
    let temperature = Math.round(weeklyData.temperature.maximum);
    return `${temperature}°`;
  }

  function minTemperature() {
    let temperature = Math.round(weeklyData.temperature.minimum);
    return `${temperature}°`;
  }

  function dayOfWeek() {
    let date = new Date(weeklyData.time * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    day = days[day];
    return day;
  }
  return (
    <div className="WeatherForecast-day">
      <div>{dayOfWeek()}</div>

      <img src={weeklyData.condition.icon_url} alt="weather-icon"></img>
      <div className="forecastTemperature">
        <span className="forecast-temp-max">{maxTemperature()}</span>
        <span className="forecast-temp-min">{minTemperature()}</span>
      </div>
    </div>
  );
}
